export default __webpack_public_path__ + "static/media/eye-green.37ec81fc.svg";